import { Fragment, ReactNode } from 'react';
import { IoIosAddCircleOutline, IoIosList, IoIosCreate, IoIosTrash } from "react-icons/io";

interface SecHeadingProps {
    icon?: ReactNode;
    label: string,
    type: 'add' | 'list' | 'update' | 'delete';
}

const SecHeading = (props: SecHeadingProps) => {
    const renderIcon = () => {
        switch (props.type) {
            case 'add':
                return <IoIosAddCircleOutline />;
            case 'list':
                return <IoIosList />;
            case 'update':
                return <IoIosCreate />;
            case 'delete':
                return <IoIosTrash />;
            default:
                return null;
        }
    };

    return (
        <Fragment>
            <div className='flex items-center space-x-2 mb-2'>
                <div className='text-green-600 dark:text-green-400'>
                    {props.icon ? props.icon : renderIcon()}
                </div>
                <h2 className='text-xl font-bold text-gray-600 dark:text-gray-200 font-public-sans !text-[14px]'>
                    {props.label}
                </h2>
            </div>
        </Fragment>
    );
};

export default SecHeading;
